import { render, staticRenderFns } from "./Create-Preventive-Maintenace.vue?vue&type=template&id=2f1c2ec1&scoped=true"
import script from "./Create-Preventive-Maintenace.vue?vue&type=script&lang=js"
export * from "./Create-Preventive-Maintenace.vue?vue&type=script&lang=js"
import style0 from "./Create-Preventive-Maintenace.vue?vue&type=style&index=0&id=2f1c2ec1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1c2ec1",
  null
  
)

export default component.exports